import { lazy } from "react";

// Dynamic imports of all mountable component.
const portals = {
  id: {
    HeaderComponent: lazy(() => import("../containers/HeaderContainer")),
    SearchSampleComponent: lazy(() =>
      import("../containers/SearchSampleContainer")
    ),
    SearchResultsPageComponent: lazy(() =>
      import("../containers/SearchResultsPageContainer")
    ),
    ProductSearchResultsPageComponent: lazy(() =>
      import("../containers/ProductSearchResultsPageContainer")
    ),
    NewsroomSearchResultsPageComponent: lazy(() =>
      import("../containers/NewsroomSearchResultsPageContainer")
    ),
    EventSearchResultsPageComponent: lazy(() =>
      import("../containers/EventSearchResultsPageContainer")
    ),
    HeroBannerSearchContainer: lazy(() =>
      import("../containers/HeroBannerSearchContainer")
    ),
    FilesTableContainer: lazy(() =>
      import("../containers/FilesTableContainer")
    ),
    ProductContactsConfiguratorContainer: lazy(() =>
      import("../containers/ProductContactsConfiguratorContainer")
    ),
    TimelineContainer: lazy(() =>
      import("../containers/TimelineContainer")
    ),
  },
  class: {
    "quiz-react": lazy(() => import("../containers/QuizContainer")),
    "tabbed-list-react": lazy(() =>
      import("../containers/TabbedListContainer")
    ),
    "social-media-tabs-react": lazy(() =>
      import("../containers/SocialMediaTabsContainer")
    ),
  },
};

export default portals;
